ProfileService = ($http) ->
  getSettingAccount: (user_id, country_lang = 'en') ->
    country_lang = if /^ja/i.test(country_lang) || /^jp/i.test(country_lang) then 'jp' else 'en'
    $http.get "/api/settings/account.json?user_id=#{user_id}&country_lang=#{country_lang}"

  getScoreCardsAnalysis: (user_id, from, to, round_type) ->
    $http.get "api/users/#{user_id}/score_cards/analysis.json?from=#{from}&to=#{to}&round_type=#{round_type}"

  getPhotoScoreCards: (user_id, page_size = 4) ->
    $http.get "api/photo_score_cards.json?user_id=#{user_id}&page_size=#{page_size}&deleted=false&order=desc"

  getFrequentlyCourses: (user_id, page_size = 5) ->
    $http.get "api/courses/frequent.json?user_id=#{user_id}&page_size=#{page_size}"

  getLatestRounds: (user_id, page_size = 5) ->
    $http.get "api/score_cards.json?user_id=#{user_id}&page_size=#{page_size}"

ProfileService.$inject = [
  '$http'
]

module.exports = ProfileService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/profile/profile-service.coffee